import Container from "react-bootstrap/Container";

function Footer() {
  return (
    <Container>
      <footer className="mt-5 py-3 d-flex justify-content-between align-items-center border-top">
        <div className="d-flex align-items-center">
          <img className="me-3" src="https://img.icons8.com/fluency/96/portfolio.png" width="32" height="32" alt="Portfolio icon" />
          <div className="d-flex flex-column">
            <span className="text-muted">
              © 2026 Achuthan R. Icons by <a href="https://icons8.com" target="_blank" rel="noopener noreferrer">Icons8</a>.
            </span>
            <span className="d-sm-block d-none text-muted">
              Photo by <a href="https://unsplash.com/@magellol" target="_blank" rel="noopener noreferrer">Thomas Lefebvre</a>.
            </span>
            <span className="d-sm-none d-block text-muted">
              Photo by <a href="https://unsplash.com/@sarahdorweiler" target="_blank" rel="noopener noreferrer">Sarah Dorweiler</a>.
            </span>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <a className="ms-3" href="mailto:r.achuthan2001@gmail.com" target="_blank" rel="noopener noreferrer">
            <img src="https://img.icons8.com/fluency/96/mail.png" alt="Mail icon" width="32" height="32" />
          </a>
          <a className="ms-3" href="https://www.linkedin.com/in/achuthan-r/" target="_blank" rel="noopener noreferrer">
            <img src="https://img.icons8.com/fluency/96/linkedin.png" alt="LinkedIn logo" width="32" height="32" />
          </a>
          <a className="ms-3" href="https://github.com/AchuthanR/" target="_blank" rel="noopener noreferrer">
            <img src="https://img.icons8.com/fluency/96/github.png" alt="GitHub logo" width="32" height="32" />
          </a>
        </div>
      </footer>
    </Container>
  );
}

export default Footer;